import { Component, EventEmitter, Input, OnInit, Output, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { Observable } from 'rxjs';
import { CtlBysSurecService } from '../ctl-bys-surec.service';
import { CtlBysSurecAramaService } from './ctl-bys-surec-arama.service';
import { OrtakService } from '../../../../services/ortak.service';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { DxButtonModule } from 'devextreme-angular';
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-bys-surec-arama',
  standalone: true,
  imports: [CommonModule,DkDxDataCtlTableComponent, DxButtonModule],
  providers:[CtlBysSurecAramaService],
  templateUrl: './ctl-bys-surec-arama.component.html',
  styleUrls: ['./ctl-bys-surec-arama.component.scss'],
})
export class CtlBysSurecAramaComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: CtlBysSurecAramaService,
    private bysSurecService:CtlBysSurecService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.bysSurecService.gridControlsList$;
    this.bysSurecService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}
